<template>
	<header id="header">
		<div class="header-content">
			<b-navbar toggleable="lg" type="light" variant="light">
		    <div class="container oversized-container">
					<b-navbar-brand to="/">
						<img src="public/images/logo.svg">
					</b-navbar-brand>

			    <div class="mobile-options">
						<router-link class="btn-validator t-150 d-lg-none" to="/validador">Validador</router-link>
						<a class="btn-open-search-m d-lg-none" @click="$refs['modal-search'].show()"><i class="fas fa-search"></i></a>

						<b-navbar-toggle target="nav-collapse">
				    	<i class="fas fa-bars"></i>
				    </b-navbar-toggle>
			    </div>

			    <b-collapse id="nav-collapse" is-nav>
			      <b-navbar-nav class="ml-auto">
							
							<li class="nav-item simple-item" :class="$root.isShop ? 'highlight-primary' : 'd-lg-none d-xl-inline'">
								 <a class="nav-link" @click="showActive" >Shop </a>
							</li>
              <b-nav-item class="simple-item d-lg-none d-xl-inline" to="/productos/2">Materias primas</b-nav-item>
              <b-nav-item class="simple-item d-lg-none d-xl-inline" to="/eum-legal">EUM Legal</b-nav-item>
              <b-nav-item class="simple-item d-lg-none d-xl-inline" to="/cromatografia-para-cannabinoide">Analisis (COA)</b-nav-item>
							<b-nav-item class="simple-item" to="/empresa">Empresa</b-nav-item>
							
							<b-nav-item class="icon-item" to="/contacto"><i class="far fa-envelope icon"></i> <span class="d-lg-none">Contacto</span></b-nav-item>
							<b-nav-item class="icon-item cart-item" to="/cart"><i class="far fa-shopping-cart icon"></i><i class="num">0</i> <span class="d-lg-none">Mi carrito</span></b-nav-item>

							<b-nav-item-dropdown right v-if="!$root.logged">
			          <template #button-content>
			            <span><i class="far fa-user icon"></i> <span class="d-lg-none">Mi cuenta</span></span>
			          </template>
			          <b-dropdown-item to="/login" v-if="!$root.logged">Iniciar sesión</b-dropdown-item>
			          <b-dropdown-item to="/registrarse" v-if="!$root.logged">Registrarse</b-dropdown-item>
			        </b-nav-item-dropdown>
              <b-nav-item v-else class="icon-item" to="/usuario"><i class="far fa-user icon"></i> <span class="d-lg-none">Mi cuenta</span></b-nav-item>

							<b-nav-item class="button-item s-1" to="/validador">Validador</b-nav-item>
							<b-nav-item class="button-item s-2 d-lg-none d-xl-inline-block"  @click="openModalDocs" @focus="textcatalog = 'Descargar'" @blur="textcatalog = 'Catalogo'"><i class="fas fa-file-pdf mr-1"></i> {{ textcatalog }}</b-nav-item>
							<li class="nav-item button-item d-lg-none s-3 btn-search-mobile">
								<a class="nav-link" @click="$refs['modal-search'].show()"><i class="fas fa-search"></i> Buscar</a>
							</li>
							<li class="nav-item button-item s-3 d-none d-lg-inline-block">
								<a class="nav-link" @click="$refs['modal-search'].show()"><i class="fas fa-search"></i></a>
							</li>
			      </b-navbar-nav>
			    </b-collapse>
		    </div>
		  </b-navbar>
		</div>

		<!-- Products menu -->
    <div class="t-250 products-menu" v-bind:class="{ active: isPActive }">
      <div class="menu-bg" @click="isPActive = false"></div>

      <div class="tablist" role="tablist">
        <div class="t-250 box-title" @click="isPActive = false">
          <h4>Shop</h4>
          <br>
          <h5>Categorias</h5>
          <i class="fas fa-chevron-left icon"></i>
        </div> 

				<b-card no-body class="mb-1">
          <b-card-header header-tag="header" role="tab">
            <router-link class="btn-toggle-fake" to="/eum-legal">EUM legal</router-link>
          </b-card-header>
				</b-card>
				<b-card no-body class="mb-1">
          <b-card-header header-tag="header" role="tab">
            <router-link class="btn-toggle-fake" to="/cromatografia-para-cannabinoide">Cromatografia para cannabinoides</router-link>
          </b-card-header>
				</b-card>

        <b-card no-body class="mb-1" v-for="(category, pcatIndex) in categories" :key="pcatIndex">
          <b-card-header header-tag="header" role="tab">
            <div v-if="category.subcategories.length" class="btn-toggle">
              <router-link :to="'/productos/'+$root._converToURL(category.name, category.id)">{{ category.name }}</router-link>
              <span class="fake-toggle" v-b-toggle="'accordion-'+pcatIndex"></span>
            </div>
            <router-link v-else class="btn-toggle-fake" :to="'/productos/'+$root._converToURL(category.name, category.id)">{{ category.name }}</router-link>
          </b-card-header>

          <b-collapse v-if="category.subcategories.length" :id="'accordion-'+pcatIndex"  accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <ul class="ul-sub-options">
                <li v-for="subcategory in category.subcategories">
                  <router-link class="t-250" :to="'/productos/'+$root._converToURL(category.name, category.id)+'/'+$root._converToURL(subcategory.name, subcategory.id)">{{ subcategory.name }}</router-link>
                </li>
              </ul>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
    <!--  -->

		<!-- Search modal -->
		<b-modal ref="modal-search" modal-class="modal-search-e" size="lg" title="" @hidden="form.keywords = null" hide-footer no-close-on-esc no-close-on-backdrop>
      <!-- NOTA: form.keywords será null siempre al cerrar el modal, esto por usar el evento @hidden -->

      <b-form @submit="onSubmitSearch">
        <b-form-group>
          <b-form-input
            v-model="form.keywords"
            type="text"
            placeholder="Buscar"
            size="lg"
            required
          ></b-form-input>
        </b-form-group>

        <b-button type="submit" class="btn-search"><i class="far fa-search"></i></b-button>
      </b-form>
    </b-modal>
		<!--  -->

    <!-- Documentos modal -->
		<b-modal ref="modal-docs" modal-class="modal-docs-e" size="lg" title="Descargar" @hidden="form.keywords = null" hide-footer no-close-on-esc no-close-on-backdrop>
      <!-- NOTA: form.keywords será null siempre al cerrar el modal, esto por usar el evento @hidden -->
        <ul>
          <li v-for="(doc,indx) in docs" :key="indx"><a :href="doc.documentUrl" target="_blank" style="color: black;"> {{ doc.document_name }}</a></li>
        </ul>
      
    </b-modal>
		<!--  -->
    <sweet-modal ref="modalLoading" :blocking="true" :hide-close-button="true">
      <div style="text-align: center;">
        <p class="mb-2 text-center">
            <img class="img-fluid" src="public/images/loading.gif" style="width: 400px;">
        </p>

        <p style="font-size: 15px;"><b>Cargando ...</b></p>
      </div>
    </sweet-modal>

	</header>
</template>

<script type="text/javascript">
export default {
	data() {
		return {
			isPActive: false,
      categories:[

      ],

			form: {
				keywords: null
			},
      pdf:null,
      docs:[],
      textcatalog:'Catalogo',
      
		}
	},

	watch: {
    '$root.isLoading':function(){
        if(this.$root.isLoading == true){
            this.$refs.modalLoading.open();
        }
        else{
          this.$refs.modalLoading.close();
        }
    },
    $route (to, from){
      // Ocultar menu cada vez que cambie la ruta
      this.isPActive = false;
    },
    '$route.path': function(){

      			if (this.$route.path.includes('productos'))
		        {
              this.$root.isShop = true;
		        } 
		        else
		        {
		        	this.$root.isShop = false;
		        }
			}
  },
  

  methods:{
		onSubmitSearch(event) {
      event.preventDefault();
			this.$router.push({path: '/productos', query: {keywords:this.form.keywords}});
      this.$refs['modal-search'].hide();
    },

    getCategories(){
      axios.get(tools.url("/api/categories")).then((response)=>{
          this.categories=response.data;
        }).catch((error)=>{
      });
    },
    getCatalogo(){
      axios.get(tools.url("/api/catalogo")).then((response)=>{
          this.docs=response.data;
        }).catch((error)=>{
      });
    },
    showActive(){
      this.isPActive = !this.isPActive;
    
      this.$router.push({path: '/productos'});
    },
    openModalDocs(){
        this.$refs['modal-docs'].show();
    },
   
  },
  mounted(){
    this.getCategories();
    this.getCatalogo();
  }
}
</script>
